import * as React from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { hot } from "react-hot-loader";
import styled from "styled-components";

import { RootState } from "../../state";
import { Company } from "../../entities";
import {
  Megaphone,
  loadMegaphonesWorker,
  openMegaphoneWorker,
  closeMegaphoneWorker,
  clickMegaphoneWorker,
} from "../../common/actions/Megaphones";
import CompanyValuesShareMegaphone from "../../company_values/components/CompanyValuesShareMegaphone";

const MEGAPHONE_LOCATION = "companies_show_values_section";
const MEGAPHONE_NAME = "suggest_share_values";

interface OwnProps {
  company: Company;
}

interface MappedProps {
  megaphone?: Megaphone | null;
}

interface MappedActions {
  loadMegaphonesWorker: typeof loadMegaphonesWorker;
  openMegaphoneWorker: typeof openMegaphoneWorker;
  closeMegaphoneWorker: typeof closeMegaphoneWorker;
  clickMegaphoneWorker: typeof clickMegaphoneWorker;
}

type Props = OwnProps & MappedProps & MappedActions;

interface State {
  showMegaphone: boolean;
}

class CompanyValuesShareMegaphoneContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showMegaphone: false,
    };
  }

  public componentDidMount() {
    this.props.loadMegaphonesWorker([MEGAPHONE_LOCATION]);
  }

  public componentWillReceiveProps(nextProps: Props) {
    if (!this.props.megaphone && nextProps.megaphone && nextProps.megaphone.name === MEGAPHONE_NAME) {
      this.setState({ showMegaphone: true });
      this.props.openMegaphoneWorker({ location: MEGAPHONE_LOCATION, megaphone: nextProps.megaphone });
    } else if (
      this.props.megaphone &&
      nextProps.megaphone &&
      !this.props.megaphone.isClosed &&
      nextProps.megaphone.isClosed
    ) {
      this.setState({ showMegaphone: false });
    }
  }

  public onClickMegaphone = () => {
    this.props.clickMegaphoneWorker({ location: MEGAPHONE_LOCATION, megaphone: this.props.megaphone! });
  };

  public onCloseMegaphone = () => {
    this.props.closeMegaphoneWorker({ location: MEGAPHONE_LOCATION, megaphone: this.props.megaphone! });
  };

  public render() {
    const { company } = this.props;

    if (!this.state.showMegaphone) {
      return null;
    }

    return (
      <CompanyValuesShareMegaphoneWrapper>
        <CompanyValuesShareMegaphone
          company={company}
          onClick={this.onClickMegaphone}
          onClose={this.onCloseMegaphone}
        />
      </CompanyValuesShareMegaphoneWrapper>
    );
  }
}

const CompanyValuesShareMegaphoneWrapper = styled.div`
  max-width: 1000px;
  margin: 40px auto 0;
`;

function mapStateToProps(state: RootState): MappedProps {
  return {
    megaphone: state.megaphones[MEGAPHONE_LOCATION],
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      loadMegaphonesWorker,
      openMegaphoneWorker,
      closeMegaphoneWorker,
      clickMegaphoneWorker,
    },
    dispatch
  );
}

const connected = connect(mapStateToProps, mapDispatchToProps)(CompanyValuesShareMegaphoneContainer);
export default hot(module)(connected);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/CompanyValuesShareMegaphoneContainer.tsx